import React from 'react';
import { Checkbox, Tooltip } from 'antd';
import {
  CheckBoxList,
  StyledCheckBox,
  MetricDivider,
  StyledText,
  CheckboxWrapper,
  CategoryWrapper,
  BetaTag,
} from './styled';
import presetStore from '@src/globalStore/presetsStore';
import PresetShortcut from '@src/components/common/PresetShortcut';
import { useCaseKeyAtom } from '@src/atoms/pageMeta';
import { useAtomValue } from 'jotai';
import CardinalityIcon from '@icons/common/cardinality.svg';
import { isBetaDimension } from './utils';

const CheckboxGroup = ({
  categoryKey,
  listCategory,
  inputList = [],
  onChange,
  setRef,
  emptyText,
  hasSearchText,
}) => {
  const category = listCategory[categoryKey];
  const emptyList = inputList.length === 0;
  const useCaseKey = useAtomValue(useCaseKeyAtom);

  const getCheckboxGroup = () => {
    if (emptyList) {
      return emptyText ?? <>No data</>;
    }
    return (
      <CheckboxWrapper count={inputList.length}>
        {inputList.map((c: any) => {
          return (
            <StyledCheckBox key={c.key}>
              <Checkbox
                onChange={onChange}
                checked={c.checked}
                disabled={c.disabled}
                value={c.key}
                key={c.key}
              >
                {c.name} {isBetaDimension({ key: c.key, name: c.name }) && <BetaTag>Beta</BetaTag>}{' '}
                {c.isHighCardinality && (
                  <Tooltip title="High Cardinality Dimension">
                    <CardinalityIcon />
                  </Tooltip>
                )}
              </Checkbox>
            </StyledCheckBox>
          );
        })}
      </CheckboxWrapper>
    );
  };

  const { presets = {} } = presetStore((state) => state);
  const presetsForCurrentDimensionCategory = (Object.values(presets) || []).filter(
    (preset: any) => preset.linkedDimensionCategory === categoryKey,
  );

  if (inputList.length === 0 && hasSearchText) {
    return null;
  }

  return (
    <CheckBoxList key={categoryKey} ref={setRef}>
      <CategoryWrapper>
        <StyledText>{category}</StyledText>

        {/* show preset links if current dashboard is not a preset itself */}
        {!useCaseKey &&
          presetsForCurrentDimensionCategory.map((preset: any) => {
            return (
              <PresetShortcut
                shortcutType="preset"
                preset={preset}
                linkFrom="dimensions"
                key={preset.key}
              />
            );
          })}
      </CategoryWrapper>
      <MetricDivider />
      {getCheckboxGroup()}
    </CheckBoxList>
  );
};

export default CheckboxGroup;
